import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { PanelComponent } from './components/panel/panel.component';
import { HeaderComponent } from './components/header/header.component';
import { ActionsComponent } from './components/actions/actions.component';
import { ContentComponent } from './components/content/content.component';
import { FooterComponent } from './components/footer/footer.component';
import { GroupComponent } from './components/group/group.component';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [
    PanelComponent,
    HeaderComponent,
    ActionsComponent,
    ContentComponent,
    FooterComponent,
    GroupComponent
  ],
  exports: [
    PanelComponent,
    HeaderComponent,
    ActionsComponent,
    ContentComponent,
    FooterComponent,
    GroupComponent
  ]
})
export class McRAIPanelModule { }
